import { getBaseUrl } from "@/utils/generic";
import { IFilteredProjectsResponse } from "./fetch";
import { IGetProjectsParams } from "./types";


// Cache in browser memory
const projectCache = new Map<string, { data: IFilteredProjectsResponse; timestamp: number }>();
const TTL = 1000 * 60 * 60 * 24 * 7; // 7 días

/**
 * Fetches filtered projects with manual client-side cache
 */
export async function fetchProjectsClientCached(params: IGetProjectsParams): Promise<IFilteredProjectsResponse> {
  const defaultParams = {
    count: -1,
    search: '',
    status: 'published',
    isArchived: false,
  };

  const mergedParams = { ...defaultParams, ...params };

  // Clean null or undefined values
  const cleanedParams = Object.fromEntries(
    Object.entries(mergedParams).filter(([, v]) => v !== undefined && v !== null)
  );

  // Convert arrays to comma-separated strings
  const queryParams = new URLSearchParams();
  for (const [key, value] of Object.entries(cleanedParams)) {
    if (Array.isArray(value)) {
      if (value.length > 0) queryParams.append(key, value.join(','));
    } else {
      queryParams.append(key, String(value));
    }
  }

  const key = queryParams.toString(); 
  const now = Date.now();
  const cached = projectCache.get(key);

  if (cached && now - cached.timestamp < TTL) {
    return { ...cached.data, _fromCache: true };
  }

  const url = `${getBaseUrl()}/api/projects-filtered?${key}`;
  const res = await fetch(url, { method: 'GET' });

  if (!res.ok) {
    const errorBody = await res.json().catch(() => ({}));
    throw new Error(errorBody?.message || `Failed to fetch projects (${res.status})`);
  }

  const data: IFilteredProjectsResponse = await res.json();

  // Guardar en caché sin el flag _fromCache
  const cacheableData = { projects: data.projects, _fromCache: false };
  projectCache.set(key, { data: cacheableData, timestamp: now });

  return cacheableData;
}